import {FC, useEffect, useState} from 'react'
import clsx from 'clsx'
import {getAdminMenuProfile} from '../../../../app/modules/auth/core/AdminAuth'

type Props = {
  sizeClass?: string
  labelClass?: string
}

/** Initials avatar; re-renders when session profile is updated or storage syncs. */
export const AdminUserAvatar: FC<Props> = ({
  sizeClass = 'symbol-35px symbol-md-40px',
  labelClass = 'fs-6',
}) => {
  const [, bump] = useState(0)
  useEffect(() => {
    const onChange = () => bump((n) => n + 1)
    window.addEventListener('shrido-admin-profile-changed', onChange)
    window.addEventListener('storage', onChange)
    return () => {
      window.removeEventListener('shrido-admin-profile-changed', onChange)
      window.removeEventListener('storage', onChange)
    }
  }, [])

  const profile = getAdminMenuProfile()
  const initials = profile?.initials ?? '?'
  const photo = profile?.avatar_url

  if (photo) {
    return (
      <span
        className={clsx('symbol symbol-circle overflow-hidden shadow-sm', sizeClass)}
        aria-hidden
      >
        <img
          src={photo}
          alt=''
          className='symbol-label'
          style={{objectFit: 'cover'}}
        />
      </span>
    )
  }

  return (
    <span
      className={clsx('symbol symbol-circle overflow-hidden shadow-sm', sizeClass)}
      aria-hidden
    >
      <span
        className={clsx(
          'symbol-label fw-bold d-flex align-items-center justify-content-center',
          'bg-primary text-white',
          labelClass,
        )}
      >
        {initials}
      </span>
    </span>
  )
}
